import { render } from "./EndScreenLossView.vue?vue&type=template&id=48580651&scoped=true"
import script from "./EndScreenLossView.vue?vue&type=script&lang=js"
export * from "./EndScreenLossView.vue?vue&type=script&lang=js"

import "./EndScreenLossView.vue?vue&type=style&index=0&id=48580651&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48580651"]])

export default __exports__